<template>
  <payments-list />
</template>

<script>
import PaymentsList from '@/components/Affiliates/PaymentsList'

export default {
  name: 'AffiliatesPayments',
  components: { PaymentsList },
}
</script>
